<template>
  <section id="welcome" class="flex-section d-flex flex-column center">
    <p class="header-1 color-white">DATA MONSTERS</p>
    <p class="header-2 color-white">Research & Consulting Group</p>
    <a
      class="trigger-next d-flex flex-column center"
      href="#wms"
      v-if="!isMobile"
    >
      <p class="text-2 kor medium color-white">Find Out Who We Are</p>
      <v-icon color="white" x-large>mdi-chevron-down</v-icon>
    </a>
  </section>
</template>

<script>
export default {
  computed: {
    isMobile() {
      return window.innerWidth < 1000;
    },
  },
};
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css?family=PT+Sans:400,700&display=swap");
@import url("https://fonts.googleapis.com/css?family=Noto+Sans+KR:400,500,700&display=swap");

p {
  font-family: "PT Sans";
  font-weight: bold;
  margin-bottom: 0 !important;
}

.trigger-next {
  position: absolute;
  bottom: 10%;
  left: 0;
  right: 0;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  cursor: pointer;
}
</style>
